import { Alert, Typography } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./LicenseShortageAlert.module.css";

export interface LicenseShortageAlertProps {
  onBuyLicenses: () => void;
  buying?: boolean;
}

export function LicenseShortageAlert({ onBuyLicenses, buying }: LicenseShortageAlertProps) {
  const { t } = useTranslation();
  return (
    <Alert
      className={styles.alert}
      type="error"
      showIcon
      message={<strong>{t("team.license.shortageTitle")}</strong>}
      data-testid="team-management-license-alert"
      description={
        <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
          <p style={{ margin: 0 }}>{t("team.license.shortageBody")}</p>
          <Typography.Link
            onClick={buying ? undefined : onBuyLicenses}
            disabled={buying}
            data-testid="team-management-license-alert-action"
            style={{ alignSelf: "flex-start" }}
          >
            {t("team.action.buyLicenses")}
          </Typography.Link>
        </div>
      }
    />
  );
}
